/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import imgMapMarker from './images/map-marker.svg';

const defaultProps = {
  point: {
    lng: 113.950497,
    lat: 22.53452,
  },
  zoom: 11,
  onPick: () => {},
  search: 0,
};

const propTypes = {
  intl: React.PropTypes.object.isRequired,
  point: React.PropTypes.object,
  zoom: React.PropTypes.number,
  onPick: React.PropTypes.func,
  search: React.PropTypes.any,
};

class MapPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      point: props.point,
      zoom: props.zoom,
    };
    this.intlMsg = new IntlMsg(props.intl, 'mappicker');
  }

  componentDidMount() {
    this.initMap();
  }

  componentWillReceiveProps(nextProps) {
    const { point, zoom, search } = nextProps;
    if (point !== this.props.point) {
      this.setState({ point });
      this.map.centerAndZoom(new BMap.Point(point.lng, point.lat), zoom);
    }
    if (zoom !== this.props.zoom) {
      this.setState({ zoom });
      this.map.centerAndZoom(new BMap.Point(point.lng, point.lat), zoom);
    }
    if (search !== this.props.search) {
      this.handleSearch(search);
    }
  }

  initMap() {
    const { point, zoom } = this.state;
    this.map = new BMap.Map('mappicker');
    this.map.setMapStyle({
      features: [],
      style: 'light',
    });
    this.map.setMaxZoom(19);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);

    this.map.centerAndZoom(new BMap.Point(point.lng, point.lat), zoom);
    this.map.setDefaultCursor('crosshair');

    const icon = new BMap.Icon(imgMapMarker, new BMap.Size(32, 32));

    this.map.addEventListener('click', (e) => {
      this.map.clearOverlays();
      this.marker = new BMap.Marker(e.point, { icon });
      this.map.addOverlay(this.marker);
      this.props.onPick(e.point);
    });
  }

  handleSearch(search) {
    const local = new BMap.LocalSearch(this.map, {
      renderOptions: { map: this.map },
    });
    local.search(search);
  }

  render() {
    return <div id="mappicker" style={{ height: '100%', width: '100%' }} />;
  }
}

MapPicker.defaultProps = defaultProps;
MapPicker.propTypes = propTypes;

export default injectIntl(MapPicker);




// WEBPACK FOOTER //
// ./src/components/MapPicker/index.jsx